import { Route, Routes } from 'react-router-dom'
import { AppLayout } from '../components/AppLayout'
import { PublicLayout } from '../components/PublicLayout'
import { RequireAuth } from '../components/RequireAuth'
import { AdminAbusePage, AdminAuditPage, AdminOverviewPage, AdminPlansPage, AdminReportsPage, AdminTagsPage, AdminUsersPage } from '../features/admin/AdminPages'
import { ForgotPasswordPage, LoginPage, RegisterPage, ResetPasswordPage, VerifyEmailPage } from '../features/auth/AuthPages'
import { DashboardPage } from '../features/dashboard/DashboardPage'
import { MessagesPage, MyReportsPage, NotificationsPage, SettingsPage } from '../features/dashboard/OwnerPages'
import { ItemDetailPage, ItemFormPage, ItemsPage, TagsPage } from '../features/items/ItemPages'
import { ContactPage, FaqPage, FeaturesPage, HomePage, HowItWorksPage, NotFoundPage, PricingPage, PrivacyPage, SafetyPage, TermsPage } from '../features/marketing/MarketingPages'
import { ReportDetailPage, ReportDirectoryPage, ReportFormPage } from '../features/reports/PublicReportPages'
import { GuestConversationPage, ScanPage } from '../features/recovery/RecoveryPages'

export function App() {
  return <Routes>
    <Route element={<PublicLayout />}>
      <Route index element={<HomePage />} />
      <Route path="how-it-works" element={<HowItWorksPage />} />
      <Route path="features" element={<FeaturesPage />} />
      <Route path="pricing" element={<PricingPage />} />
      <Route path="faq" element={<FaqPage />} />
      <Route path="contact" element={<ContactPage />} />
      <Route path="privacy" element={<PrivacyPage />} />
      <Route path="terms" element={<TermsPage />} />
      <Route path="safety" element={<SafetyPage />} />
      <Route path="login" element={<LoginPage />} />
      <Route path="register" element={<RegisterPage />} />
      <Route path="forgot-password" element={<ForgotPasswordPage />} />
      <Route path="reset-password" element={<ResetPasswordPage />} />
      <Route path="verify-email" element={<VerifyEmailPage />} />
      <Route path="reports" element={<ReportDirectoryPage />} />
      <Route path="reports/:id" element={<ReportDetailPage />} />
      <Route path="report-found" element={<ReportFormPage type="found" />} />
      <Route element={<RequireAuth />}><Route path="report-lost" element={<ReportFormPage type="lost" />} /></Route>
    </Route>

    <Route path="scan/:token" element={<ScanPage />} />
    <Route path="recovery-conversation/:token" element={<GuestConversationPage />} />

    <Route element={<RequireAuth />}>
      <Route path="app" element={<AppLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="items" element={<ItemsPage />} />
        <Route path="items/new" element={<ItemFormPage />} />
        <Route path="items/:id" element={<ItemDetailPage />} />
        <Route path="tags" element={<TagsPage />} />
        <Route path="reports" element={<MyReportsPage />} />
        <Route path="messages" element={<MessagesPage />} />
        <Route path="notifications" element={<NotificationsPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
    </Route>

    <Route element={<RequireAuth admin />}>
      <Route path="admin" element={<AppLayout admin />}>
        <Route index element={<AdminOverviewPage />} />
        <Route path="users" element={<AdminUsersPage />} />
        <Route path="reports" element={<AdminReportsPage />} />
        <Route path="abuse" element={<AdminAbusePage />} />
        <Route path="tags" element={<AdminTagsPage />} />
        <Route path="plans" element={<AdminPlansPage />} />
        <Route path="audit" element={<AdminAuditPage />} />
      </Route>
    </Route>

    <Route element={<PublicLayout />}><Route path="*" element={<NotFoundPage />} /></Route>
  </Routes>
}

